<script setup lang="ts">
  // Vue core imports
  import type { PropType } from 'vue'

  // External library imports
  import { HLSpin } from '@platform-ui/highrise'

  // Props definitions
  const props = defineProps({
    id: {
      type: String,
      required: true,
    },
    size: {
      type: String as PropType<'sm' | 'md' | 'lg'>,
      required: false,
      default: 'md',
    },
  })

  defineOptions({ name: 'CPSpin', inheritAttrs: false })
</script>

<template>
  <HLSpin v-bind="$attrs" :id="props.id" :size="props.size" />
</template>
